const blogs = {
  seeMore: "Afficher plus",
  blog: "Blog",
  latest: "Nos derniers articles",
  create: "Créer une note de blog",
  edit: "Modifier une note de blog",
  preview: "Prévisualisation de la note de blog",
  link: "Lien vers l'article",
  postsBlog: "Notes de blog",
  createBlogInstruction:
    "La note de blog sera affichée en premier sur la page 'On Parle De Nous'",
  missingDataInLanguages: "Donnée manquante dans une ou plusieurs langues.",
  emptyPage: "Il n'y pas d'article sur cette page.",
  blogDetail: "Détails note de blog",
};

export default blogs;
